import * as t from './actionTypes';
import { DEFAULT_FETCH_NOTIFICATIONS_PARAMETERS } from './constants';
import { Filters, NotificationCount, NotificationItem, NotificationsState } from './types';

export type NotificationsAction = {
  filters?: Filters;
  isFilterUpdate?: boolean;
  isLoading?: boolean;
  notificationCount?: NotificationCount;
  notificationIds?: number[];
  notifications?: NotificationItem[];
  type: string;
};

const initialState: NotificationsState = {
  filters: DEFAULT_FETCH_NOTIFICATIONS_PARAMETERS,
  isLoading: false,
  notificationCount: {
    total: 0,
    totalRead: 0,
    totalUnread: 0,
  },
  notifications: [],
};

const notificationsReducer = (state = initialState, action: NotificationsAction) => {
  switch (action?.type) {
    case t.FETCH_NOTIFICATIONS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_NOTIFICATION_COUNT_RESPONSE: {
      return {
        ...state,
        notificationCount: action.notificationCount,
      };
    }
    case t.FETCH_NOTIFICATIONS_RESPONSE: {
      return {
        ...state,
        notifications: action.isFilterUpdate
          ? action.notifications
          : [...state.notifications, ...(action.notifications || [])],
        isLoading: false,
      };
    }
    case t.UPDATE_NOTIFICATIONS_RESPONSE: {
      return {
        ...state,
        notifications: state.notifications.filter(
          ({ notification }) => !action.notificationIds?.includes(notification.id),
        ),
      };
    }
    case t.UPDATE_NOTIFICATION_CENTER_FILTERS: {
      return {
        ...state,
        filters: action.filters,
      };
    }
    default: {
      return state;
    }
  }
};

export default notificationsReducer;
